import styled from "styled-components"
import Colors from "utils/Colors"

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  border: 1px solid ${Colors.lightGray};
`

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${Colors.textColor};
  background-color: ${Colors.lightGray};
  padding: 1rem;
  width: 100%;
`
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-transform: none;
  padding: 1rem;
  width: 100%;
  heigth: 100%;
`
